import { BadgeProps, Badge as ChakraBadge } from "@chakra-ui/react";
import { ReactElement } from "react";

type CustomBadgeProps = {
  slotLeft?: ReactElement | undefined;
};

export const RoundedBadge = ({
  slotLeft,
  children,
  size = "lg",
  ...rest
}: BadgeProps & CustomBadgeProps) => {
  return (
    <ChakraBadge
      gap={1}
      fontWeight={"500"}
      fontSize={"14px"}
      lineHeight={"20px"}
      letterSpacing={"-0.18px"}
      borderRadius={"3xl"}
      borderColor="bg.subtle"
      size={size}
      {...rest}
    >
      {slotLeft}
      {children}
    </ChakraBadge>
  );
};
